const carouselItems = [
  {
    title: '2026暑期档：大片扎堆，谁能称王？',
    desc: '今年暑期档堪称史上最强——科幻巨制、动画大片、动作爽片轮番上阵。我们整理了最值得期待的八部影片，从卡司到制作，提前为你划重点。',
    tag: '焦点策划',
    img: 'https://readdy.ai/api/search-image?query=Epic%20summer%20blockbuster%20cinematic%20scene%20with%20dramatic%20sunset%20sky%2C%20movie%20set%20vibe%2C%20warm%20golden%20and%20crimson%20lighting%2C%20professional%20cinematography%2C%20wide%20heroic%20composition%2C%20rich%20atmospheric%20mood&width=1200&height=600&seq=carousel-feat-01-v2&orientation=landscape',
    imgAlt: '2026暑期档焦点策划',
  },
  {
    title: '国漫崛起之路：从跟跑到领跑的十年',
    desc: '从2015年《大圣归来》点燃希望，到如今技术、叙事、票房全面开花。我们回溯国漫十年的蜕变历程，看中国动画人如何一步步将梦想照进现实。',
    tag: '深度专题',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20studio%20workspace%20with%20concept%20sketches%20displayed%2C%20warm%20creative%20lighting%2C%20professional%20art%20direction%2C%20rich%20textures%2C%20cinematic%20atmosphere%2C%20behind%20the%20scenes%20vibe&width=1200&height=600&seq=carousel-feat-02-v2&orientation=landscape',
    imgAlt: '国漫崛起深度专题',
  },
  {
    title: '悬疑宇宙：全球高分烧脑片终极盘点',
    desc: '西班牙的层层反转、韩国的社会派推理、北欧的冷峻风格——我们跨越国界，为你梳理出一份真正经得起考验的悬疑片单，每一部都值得二刷。',
    tag: '精选片单',
    img: 'https://readdy.ai/api/search-image?query=Classic%20film%20noir%20detective%20office%20with%20venetian%20blinds%20shadow%2C%20warm%20amber%20desk%20lamp%2C%20mysterious%20moody%20atmosphere%2C%20vintage%20cinema%20aesthetic%2C%20professional%20photography%2C%20rich%20contrast&width=1200&height=600&seq=carousel-feat-03-v2&orientation=landscape',
    imgAlt: '悬疑电影终极盘点',
  },
  {
    title: '影视技术进化论：从胶片到AI生成',
    desc: '虚拟制作、AI修复、实时渲染——电影工业正经历百年未有的技术变革。我们带你了解这些新技术如何改变拍电影的方式，以及它们对观众意味着什么。',
    tag: '行业观察',
    img: 'https://readdy.ai/api/search-image?query=Futuristic%20film%20editing%20suite%20with%20holographic%20displays%2C%20warm%20ambient%20tech%20lighting%2C%20professional%20postproduction%20environment%2C%20clean%20modern%20workspace%2C%20cinematic%20color%20grading%2C%20sleek%20design&width=1200&height=600&seq=carousel-feat-04-v2&orientation=landscape',
    imgAlt: '影视技术进化论行业观察',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="bg-background-50 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap mb-3">
            特别推荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="text-foreground-600 text-sm mt-2">编辑团队倾力打造，深入影视世界的每一个角落</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {carouselItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 group cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.imgAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 text-xs font-medium rounded bg-accent-500/85 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}